import { DeleteOutlined, FormOutlined } from "@ant-design/icons";
import AppBackButton from "@nxsys/components/AppBackButton";
import AppButton from "@nxsys/components/AppButton";
import { STATUTORY_PAYMENT_OPTION, STATUTORY_PAYMENT_TYPE } from "@nxsys/constants/statutory";
import { useNavigateWithQuery } from "@nxsys/hooks/useNavigateWithQuery";
import { AppDispatch, AppState } from "@nxsys/store";
import { deleteStatutory } from "@nxsys/store/slices/statutory/action";
import { DeleteStatutoryParams } from "@nxsys/store/slices/statutory/types";
import { Modal } from "antd";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

const DetailHeader = ({
  isEditing,
  toggleEditing,
  onSave,
}: {
  isEditing: boolean;
  toggleEditing: () => void;
  onSave: () => void;
}) => {
  const { type = '' } = useParams();
  const { statutoryDetail, loading } = useSelector((state: AppState) => state.statutoryStore);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigateWithQuery();
  const location = useLocation();
  const pathname = location.pathname;

  const handleGoBack = () => navigate(pathname.includes('statutory-leave') ? '/statutory-leave' : '/statutory-payment');

  const handleDeleteStatutory = async (params: DeleteStatutoryParams) => {
    Modal.confirm({
      title: 'Confirm to delete',
      content: 'Are you sure want to delete?',
      onOk: async () => {
        await dispatch(deleteStatutory(params))
        handleGoBack();
      }
    })
  }

  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-x-4">
        <AppBackButton onClick={handleGoBack} />
        <div>
          <h2 className="text-truncate" key="title">
            {statutoryDetail?.subcontractor?.fullName ?? ''}
          </h2>
          <div className="flex items-center gap-x-2 mt-2">
            <span className="text-[#5C656E]">{`ID: ${statutoryDetail?.subcontractor?.id ?? ''}`}</span>
            <span className="inline-block w-px h-5 bg-[#EAECEF]"></span>
            <span className="text-[#5C656E]">{`Leave Type: ${STATUTORY_PAYMENT_OPTION.find((o) => o.value === type)?.label ?? type}`}</span>
          </div>
        </div>
      </div>
      <div className="flex gap-x-2 items-center">
        {!isEditing && (
          <>
            <AppButton
              name="Delete"
              variant="outlined"
              leftIcon={<DeleteOutlined />}
              onClick={() => handleDeleteStatutory([{
                  id: statutoryDetail?.id,
                  type: type as STATUTORY_PAYMENT_TYPE,
              }])}
              disabled={loading}
            />
            <AppButton
              name="Edit"
              leftIcon={<FormOutlined />}
              onClick={toggleEditing}
              disabled={loading}
            />
          </>
        )}
        {isEditing && (
          <>
            <AppButton
              name="Cancel"
              variant="outlined"
              onClick={toggleEditing}
            />
            <AppButton
              name="Save"
              onClick={onSave}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default DetailHeader;